import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
const activeTabStyles = css `
  color: ${theme.semantic.foreground.primary};
  background-color: ${theme.semantic.surface.sunken};

  &:disabled {
    /* Shouldn't happen, but just in case */
    color: ${theme.swatches.warm[500]};
  }
`;
const hoverTabStyles = css `
  background-color: ${theme.semantic.surface.secondary};
`;
export const TabNavContainer = styled.div `
  display: flex;
  flex-shrink: 0;
  height: ${pxToRem(40)};
  background-color: ${theme.semantic.surface.primary};
  border-bottom: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const ScrollableTabNav = styled.div `
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  scrollbar-width: none;
  overflow: auto hidden;
`;
export const ContentContainer = styled.div ``;
export const TabContainer = styled.button `
  height: ${pxToRem(28)};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  position: relative;
  cursor: pointer;
  appearance: none;
  border: 0;
  ${interactiveTransition};
  white-space: nowrap;
  flex: 0 1 auto;
  color: ${theme.semantic.text[100]};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.md};
  background-color: transparent;

  ${({ $stretch }) => $stretch &&
    css `
      flex: 1 1 auto;
    `}

  &:not(:last-child) {
    margin-right: ${theme.spacing.md};
  }

  &:hover:not(:disabled) {
    ${hoverTabStyles};
  }

  &:focus-visible {
    outline-offset: ${pxToRem(-1)};
    outline: ${pxToRem(1)} solid ${theme.swatches.blue[200]};
  }

  ${(props) => props.$isActive && activeTabStyles};

  &:disabled {
    color: ${theme.swatches.warm[500]};
    cursor: auto;
  }
`;
export const TabBadge = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.semantic.surface.sunken};
  height: ${pxToRem(16)};
  min-width: ${pxToRem(16)};

  ${interactiveTransition};

  ${(props) => props.$isActive &&
    `
    background-color: ${theme.semantic.surface.primary};
    `}
`;
